import axios from 'axios';

// const CryptoJS = require('crypto-js');
/* eslint-disable */
const member_api = 'emc-api-server.eilis-ai.com';



const state = {
    shop: null
}

const getters = {
    shop: state => state.shop
}

const mutations = {
    getShopData(state, payload) {
        state.shop = payload;
    }
}

const actions = {
    recalculateShopItemNum({ }, payload) {
        const apiUrl = `https://${member_api}/recalculateShopItemNum`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res;
            })
    },
    getShopLink({ commit, state }, payload) {
        const apiUrl = `https://emc-action.eilis-ai.com/getShop`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                commit('getShopData', res.data);
                return res;
            })
            .catch((err) => {
                console.log(err);
            })
    },
    getOrderLink({ commit, state }, payload) {
        const apiUrl = `https://${member_api}/api/getOrder`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res;
            })
    },
    comsumeBroadcast({ }, payload) {
        const apiUrl = `https://${member_api}/comsumeBroadcast`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res;
            })
    },
    userLoginGift({ }, payload) {
        const apiUrl = `https:/${member_api}/loginGift`;
        axios.post(apiUrl, payload);
    },
    checkLoginStatus({ }, payload) {
        const apiUrl = `https://${member_api}/checkLogin`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res;
            });
    },
    exchangePoint({ }, payload) {
        const apiUrl = `https://${member_api}/exchangeBeta`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res;
            });
    },
}

export default {
    namespaced: true,
    state, getters, mutations, actions
}